import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EActionTypes {
  SetPushEnabled = 'filters/setPushEnabled',
}

export const setPushEnabled = actionGenerator<EActionTypes.SetPushEnabled, boolean>(EActionTypes.SetPushEnabled);

export type TSubscriptionActions = ReturnType<typeof setPushEnabled>;
